module.exports = __webpack_public_path__ + "img/workforce-obreros.b12a304a.webp";